import { useEffect } from 'react';
import { useMyModules } from '@/api/modules';
import { useAuthStore } from '@/auth/authStore';
import { useModuleStore } from './moduleStore';

/**
 * Keeps the module store in step with the server. Mounted once in the signed-in layout: it asks
 * which modules the organisation has on, pushes the answer into the store, and re-asks whenever
 * React Query refetches (focus, invalidation after a switch, a 403 `ModuleDisabled`).
 */
export function useModuleSync(): void {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const setModules = useModuleStore((s) => s.setModules);
  const { data } = useMyModules(isAuthenticated);
  useEffect(() => {
    if (data) setModules(data);
  }, [data, setModules]);
}
